import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const TableRatiosTemplateWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "table-ratios-template-wrapper",
  },
)`
  width: 100%;
  border: 1px dashed ${greyMui._400};
  border-radius: 5px;
  padding: 12px;

  .table-ratios__container {
    display: flex;
    flex-direction: column;
    gap: 14px;

    .table-ratios-chip {
      transition: filter 0.55s ease-out;
    }

    &[data-inner-editing="true"] {
      .display-mode {
        filter: blur(3px) grayscale(100%) !important;
        pointer-events: none !important;
        transition: filter 0.55s ease-out;
      }

      .add_item_button_wrapper .MuiButton-root {
        filter: blur(3px) grayscale(100%);
        pointer-events: none;
        transition: filter 0.55s ease-out;
      }
    }
  }

  .add_item_button_wrapper {
    height: 30px;
    display: flex;
  }
`;

export const TableRatiosItemsHeaderStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "table-ratios-header",
  },
)`
  display: grid;
  grid-template-columns: 1fr 50px 72px 50px 80px;
  align-items: center;
  border: 1px solid ${greyMui._200};
  border-radius: 5px;
  padding: 6px;
  background-color: ${rydeColors.smoke};
  transition: filter 0.55s ease-out;
`;

export const RatioItemDisplayStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "table-ratios-display-item",
})`
  display: grid;
  grid-template-columns: 1fr 50px 72px 50px 80px;
  align-items: center;
  border: 1px solid ${greyMui._200};
  border-radius: 5px;
  padding: 6px;
  transition: filter 0.55s ease-out;

  .to_cell {
    display: flex;
    align-items: center;
    gap: 3px;
  }
`;

export const RatioItemEditStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "table-ratios-edit-item",
})`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  border: 1px solid ${greyMui._200};
  padding: 10px;
  border-radius: 5px;
  .from_to_container {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 5px;
    align-items: center;
  }
  .overnight_marker {
    display: flex;
    align-items: center;
  }
  .buttons_edit_view {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
`;
